import React, {MouseEvent, useCallback, useState} from 'react';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import EntityActionsMenu from 'shared/ui/MoreActions/EntityActionsMenu';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';

import {tariffVariantAPI} from '../../api/tariffVariantAPI';

import type {ITariffVariant} from 'entities/tariff';

type TariffVariantMenuProps = {
    item: ITariffVariant;
    onEditClick: (_event: MouseEvent) => void;
};

const TariffVariantMenu: React.FC<TariffVariantMenuProps> = ({item, onEditClick}) => {
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [deleteTariffVariant, {isLoading}] = tariffVariantAPI.useDeleteTariffVariantMutation();

    const closeDelete = useCallback(() => setIsDeleteOpen(false), []);

    const onClickDelete = useCallback((event: MouseEvent) => {
        event.stopPropagation();
        setIsDeleteOpen(true);
    }, []);

    const onConfirmDelete = useCallback(async() => {
        const result = await deleteTariffVariant(item.id);
        if ('error' in result) return;
        toast.success(t`Вариант тарифа успешно удалён`);
        closeDelete();
    }, [deleteTariffVariant, item.id, closeDelete]);

    return (
        <>
            <EntityActionsMenu onEdit={onEditClick} onDelete={onClickDelete} placement="auto"/>
            <ConfirmModal
                variant="delete"
                open={isDeleteOpen}
                handleClose={closeDelete}
                header={t`Удаление пакета`}
                title={t`Удалить вариант тарифа`}
                name={`ID ${item.id}`}
                confirmText={t`Удалить`}
                onConfirm={onConfirmDelete}
                isLoading={isLoading}
            />
        </>
    );
};

export default React.memo(TariffVariantMenu);
